var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDoubleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "chevron-double-up_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 13.953a1 1 0 010-1.414l7-7a1 1 0 011.414 0l7 7a1 1 0 01-1.414 1.414L12 7.66l-6.293 6.293a1 1 0 01-1.414 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 19.453a1 1 0 010-1.414l7-7a1 1 0 011.414 0l7 7a1 1 0 01-1.414 1.414L12 13.16l-6.293 6.293a1 1 0 01-1.414 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMjkzIDEzLjk1M2ExIDEgMCAwMTAtMS40MTRsNy03YTEgMSAwIDAxMS40MTQgMGw3IDdhMSAxIDAgMDEtMS40MTQgMS40MTRMMTIgNy42NmwtNi4yOTMgNi4yOTNhMSAxIDAgMDEtMS40MTQgMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4yOTMgMTkuNDUzYTEgMSAwIDAxMC0xLjQxNGw3LTdhMSAxIDAgMDExLjQxNCAwbDcgN2ExIDEgMCAwMS0xLjQxNCAxLjQxNEwxMiAxMy4xNmwtNi4yOTMgNi4yOTNhMSAxIDAgMDEtMS40MTQgMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgChevronDoubleUp as ReactComponent };